import axios from 'axios';

export default {
    setAuth: ({ commit }, payload) => {
        commit('setAuth', payload);
    },
    clearAuth: ({ commit }, payload) => {
        commit('clearAuth', payload);
    },
    setLoginLoading: ({ commit }, loading ) => {
        commit('setLoginLoading', loading);
    },
    setCommonErrors ({ commit }, errors) {
        commit('setCommonErrors', errors);
    },
    setErrorMessage ({ commit }, msg) {
        commit('setErrorMessage', msg);
    },
    setSuccessMessage ({ commit }, msg) {
        commit('setSuccessMessage', msg);
    },
    setExportFile ({ commit }, exportFile) {
        commit('setExportFile', exportFile);
    },
    setLoading: ({ commit }, loading ) => {
        commit('setLoading', loading);
    },
    setSettings ({ commit }, settings) {
        commit('setSettings', settings);
    },
    setDashboardTarget ({ commit }, dashboardTarget) {
        commit('setDashboardTarget', dashboardTarget);
    },
    setDashboardTargetUser ({ commit }, dashboardTargetUser) {
        commit('setDashboardTargetUser', dashboardTargetUser);
    },

    setProductsLoading: ({ commit }, loading ) => {
        commit('setProductsLoading', loading);
    },
    setQuoteProductsLoading: ({ commit }, loading ) => {
        commit('setQuoteProductsLoading', loading);
    },
    setQuotations: ({ commit }, payload) => {
        commit('setQuotations', payload);
    },
    setQuotationLoading: ({ commit }, loading ) => {
        commit('setQuotationLoading', loading);
    },
    setNewQuotation: ({ commit }, payload) => {
        commit('setNewQuotation', payload);
    },
    setPriceCalculation: ({ commit }, payload) => {
        commit('setPriceCalculation', payload);
    },
    setQuotationsFilter: ({ commit }, payload) => {
        commit('setQuotationsFilter', payload);
    },
    setCustomers: ({ commit }, payload) => {
        commit('setCustomers', payload);
    },
    setCustomerLoading: ({ commit }, loading ) => {
        commit('setCustomerLoading', loading);
    },
    setVendorFilter: ({ commit }, payload) => {
        commit('setVendorFilter', payload);
    },
    setOrders: ({ commit }, payload) => {
        commit('setOrders', payload);
    },
    setOrdersLoading: ({ commit }, loading ) => {
        commit('setOrdersLoading', loading);
    },
    setOrderMaxNumOfShipToAddress: ({ commit }, maxNumOfShipToAddress ) => {
        commit('setOrderMaxNumOfShipToAddress', maxNumOfShipToAddress);
    },
    setNewOrder: ({ commit }, payload) => {
        commit('setNewOrder', payload);
    },
    setOrdersShowFilters: ({ commit }, payload) => {
        commit('setOrdersShowFilters', payload);
    },
    setOrdersFilterData: ({ commit }, payload) => {
        commit('setOrdersFilterData', payload);
    },
    setSalesOrderMenuItems: ({ commit }, payload) => {
        commit('setSalesOrderMenuItems', payload);
    },

    setPurchaseOrders: ({ commit }, payload) => {
        commit('setPurchaseOrders', payload);
    },
    setPurchaseOrdersLoading: ({ commit }, loading ) => {
        commit('setPurchaseOrdersLoading', loading);
    },
    setNewPurchaseOrder: ({ commit }, payload) => {
        commit('setNewPurchaseOrder', payload);
    },
    setPurchaseOrdersShowFilters: ({ commit }, payload) => {
        commit('setPurchaseOrdersShowFilters', payload);
    },
    setPurchaseOrdersFilterData: ({ commit }, payload) => {
        commit('setPurchaseOrdersFilterData', payload);
    },
    setPurchaseOrderMenuItems: ({ commit }, payload) => {
        commit('setPurchaseOrderMenuItems', payload);
    },

    setTaskShowFilters: ({ commit }, payload) => {
        commit('setTaskShowFilters', payload);
    },
    setTaskFilterData: ({ commit }, payload) => {
        commit('setTaskFilterData', payload);
    },

    setReminderShowFilters: ({ commit }, payload) => {
        commit('setReminderShowFilters', payload);
    },
    setReminderFilterData: ({ commit }, payload) => {
        commit('setReminderFilterData', payload);
    },
    setCarriers: ({ commit }, carriers) => {
        commit('setCarriers', carriers);
    },
    resetState: ({ commit }) => {
        commit('resetState');
    },

    backShipmentState: ({ commit }, payload) => {
        commit('backShipmentState', payload);
    },
}
